import { produce } from 'immer'
import { Reducer } from 'redux'

import { LEGISLATION_REFERENCE_SET_HIGHLIGHTED } from 'redux/actions/types'

interface LegislationReferenceState {
  highlighted: string[]
}

const initialState: LegislationReferenceState = {
  highlighted: []
}

const legislationReference: Reducer<LegislationReferenceState, any> = (state = initialState, action: any) => {
  switch (action.type) {
    case LEGISLATION_REFERENCE_SET_HIGHLIGHTED:
      return produce(state, draft => {
        draft.highlighted = action.highlighted
      })
    default:
      return state
  }
}

export default legislationReference
